import Image from 'next/image';
import React, { useCallback } from 'react';

import styles from './styles.module.scss';

export interface FeatureProps {
  id: string | number;
  icon: string | React.ReactNode;
  title: string;
  text: string;
  onClick?: (id: string | number, title: string) => void;
  premium?: boolean;
}

export const Feature: React.FC<FeatureProps> = ({
  icon,
  text,
  title,
  id,
  onClick,
  premium,
}) => {
  const onClickHandler = useCallback(() => {
    onClick?.(id, title);
  }, [onClick, id]);
  let iconElement = icon;

  if (typeof icon === 'string') {
    iconElement = <Image src={icon} width={48} height={48} />;
  }

  return (
    <div className={styles.container} onClick={onClickHandler}>
      <div className={styles.image}>
        <div className={styles.imageContainer}>{iconElement}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          <span>{title}</span>
          {premium ? <span className={styles.premium}>Premium</span> : null}
        </div>
        <div className={styles.text}>{text}</div>
      </div>
      <div className={styles.action}>
        <Image
          src="/pagesImages/common/Feature/next.png"
          width={16}
          height={16}
        />
      </div>
    </div>
  );
};
